const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsProdutos = { name: 'Produtos', pathName: null, action: 'produtos' }

export default [
  {
    path: 'arvore-produtos',
    name: 'arvore-produtos',
    component: () => import('@/modules/produtos/arvore-produtos/views/pages/ArvoreProdutos.vue'),
    meta: {
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsProdutos,
        {
          name: 'Árvore de produtos',
          pathName: null,
        },
      ],
      title: 'Árvore de produtos',
      requiredUserPermissions: ['produtos/arvore-produtos'],
    },
  },
]
